import { Component, OnInit,Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-ConformationDialog',
  templateUrl: './ConformationDialog.component.html',
  styleUrls: ['./ConformationDialog.component.css']
})
export class ConformationDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ConformationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }

  onYesClick(){
    this.dialogRef.close(true);
  }

  onNoClick(){
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// ./src/app/shelf/popups/ConformationDialog/ConformationDialog.component.ts